import * as React from 'react';
import { NavLink } from "react-router-dom";
import { observer, inject } from "mobx-react";
import history from '../history';
import { Fab } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import InfoIcon from '@material-ui/icons/Info';

// =====================================
// STORES
import { IOrdersStore } from '../../store/OrdersStore';

// =====================================
// COMPONENTS
import { Header } from '../Layout/Header';
import { Loader } from '../Layout/Loader';

@inject((allStores: any) => ({
    ordersStore: allStores.store.ordersStore as IOrdersStore
}))

@observer
export default class Info extends React.Component<{ ordersStore?: IOrdersStore; match?: any }, {}> {

    componentDidMount() {
        const customerId = this.props.match?.params?.customerId;
        this.props.ordersStore.getCustomerInfo(customerId);
    }

    componentWillUnmount() {
        this.props.ordersStore.reset();
    }

    redirectToNewOrder = () => {
        history.push(`/neworder/${this.props.match?.params?.customerId}`);
    }

    render() {

        if (this.props.ordersStore.isLoading) {
            return <Loader />;
        }

        return (
            <div>
                <Header
                    title={`Klijent: ${this.props.ordersStore.customer.fullName}`}
                    isBackButtonVisible={true}
                    url="/customers" />

                <Fab color="primary" aria-label="add" className="add-btn" onClick={this.redirectToNewOrder}>
                    <AddIcon />
                </Fab>

                <div className="container">
                    <div className="customer-info-container">
                        <div className="customer-info-row">
                            <span className="info-label">Ukupan dug:</span>
                            {this.props.ordersStore.customer.accountsReceivables !== undefined ? this.props.ordersStore.customer.accountsReceivables.toLocaleString("sr", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0,00"} RSD
                        </div>
                        <div className="customer-info-row">
                            <span className="info-label">Dug van valute:</span>
                            {this.props.ordersStore.customer.overdueAccountsReceivables !== undefined ? this.props.ordersStore.customer.overdueAccountsReceivables.toLocaleString("sr", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0,00"} RSD
                        </div>
                        <div className="customer-info-row">
                            <span className="info-label">Rabat:</span>
                            {this.props.ordersStore.customer.paymentInformation.discountPrimary !== undefined ? this.props.ordersStore.customer.paymentInformation.discountPrimary.toLocaleString("sr", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0,00"}
                        </div>
                        <div className="customer-info-row">
                            <span className="info-label">Valuta plaćanja:</span>
                            {this.props.ordersStore.customer.paymentInformation.paymentTerms}
                        </div>
                    </div>
                </div>

                <div className="footer-icon-container">
                    <NavLink className="footer-icon col-4" to={`/orders/${this.props.match?.params?.customerId}`}>
                        <AddShoppingCartIcon />
                        <div>Aktivne</div>
                    </NavLink>
                    <NavLink className="footer-icon col-4" to={`/acceptedorders/${this.props.match?.params?.customerId}`}>
                        <ShoppingCartIcon />
                        <div>Realizovane</div>
                    </NavLink>
                    <NavLink className="footer-icon col-4" to={`/info/${this.props.match?.params?.customerId}`}>
                        <InfoIcon />
                        <div>Info</div>
                    </NavLink>
                </div>
            </div>
        );
    }
}